import { ButtonType, CustomButton, Table } from "soprasteria-ui-library";
import * as React from 'react';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { IEpiReport } from '../../../models/IEpiReport';
import { NINETEEN_TO_TWENTYTHREE_YEARS, NINETEEN_YEARS, SEVEN_TO_EIGHTEEN_YEARS, THIRTEEN_YEARS, THREE_AND_SEVEN_YEARS, ONE_TO_SIX_YEARS, TWENTYTHREE_YEARS } from '../../../utils/EpiReportTypeConstants';
import './EpiReportInformation.scss';

interface IEpiReportInformation {
    epiReport: IEpiReport;
    populateEpiReportModal: (epiReport: IEpiReport) => void;
    onDelete?: (epiReportId: number) => void;
}

export const EpiReportInformation: React.FunctionComponent<IEpiReportInformation> = ({ epiReport, populateEpiReportModal, onDelete }) => {
    const [showChildTeethFields, setShowChildTeethFields] = React.useState<boolean>(false);
    const [showPermanentTeethFields, setShowPermantentTeethFields] = React.useState<boolean>(false);
    const [showAdultExtraFields, setShowAdultExtraFields] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (epiReport.epiReportTypeId == THREE_AND_SEVEN_YEARS || epiReport.epiReportTypeId == ONE_TO_SIX_YEARS) {
            setShowChildTeethFields(true);
        }
        if (epiReport.epiReportTypeId == THIRTEEN_YEARS || epiReport.epiReportTypeId == SEVEN_TO_EIGHTEEN_YEARS || epiReport.epiReportTypeId == NINETEEN_YEARS || epiReport.epiReportTypeId == TWENTYTHREE_YEARS || epiReport.epiReportTypeId == NINETEEN_TO_TWENTYTHREE_YEARS) {
            setShowPermantentTeethFields(true);
        }
        if (epiReport.epiReportTypeId == NINETEEN_YEARS || epiReport.epiReportTypeId == TWENTYTHREE_YEARS || epiReport.epiReportTypeId == NINETEEN_TO_TWENTYTHREE_YEARS) {
            setShowAdultExtraFields(true);
        }
    }, [])

    return (
        <>
            <Table>
                <thead className="epiReport">
                    <tr>
                        {
                            showChildTeethFields ?
                                <th title="Antal mjölktänder med dentinkaries">dt</th>
                                : null
                        }
                        {
                            showChildTeethFields ?
                                <th title="Antal mjölktänder med fyllning (ej registrerade som karies)">ft</th>
                                : null
                        }
                        {
                            showChildTeethFields ?
                                <th title="Antal mjölktänder som extraherats pga karies">mt/et</th>
                                : null
                        }
                        {
                            showPermanentTeethFields ?
                                <th title="Antal tänder med dentinkaries">DT</th>
                                : null
                        }
                        {
                            showPermanentTeethFields ?
                                <th title="Antal tänder med fyllning (ej registrerade som karies)">FT</th>
                                : null
                        }
                        {
                            showAdultExtraFields ?
                                <th title="Antal sidoytor med dentinkaries">DS-a</th>
                                : null
                        }
                        {
                            showAdultExtraFields ?
                                <th title="Antal sidoytor med fyllning (ej registrerade som karierade)">FS-a</th>
                                : null
                        }
                        <th title="Datum när EPI-rapporten utfördes">Behandlingsdatum</th>
                        {
                            onDelete ?
                                <th className="delete-btn">Ta bort</th>
                                : null
                        }
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {
                            showChildTeethFields ?
                                <td>{epiReport.dtChild}</td>
                                : null
                        }
                        {
                            showChildTeethFields ?
                                <td>{epiReport.ftChild}</td>
                                : null
                        }
                        {
                            showChildTeethFields ?
                                <td>{epiReport.mtetChild}</td>
                                : null
                        }
                        {
                            showPermanentTeethFields || showPermanentTeethFields ?
                                <td>{epiReport.dtAdult}</td>
                                : null
                        }
                        {
                            showPermanentTeethFields || showPermanentTeethFields ?
                                <td>{epiReport.ftAdult}</td>
                                : null
                        }
                        {
                            showAdultExtraFields ?
                                <td>{epiReport.dSaAdult}</td>
                                : null
                        }
                        {
                            showAdultExtraFields ?
                                <td>{epiReport.fSaAdult}</td>
                                : null
                        }
                        <td>{dateTimeToDateString(epiReport.assessmentDate)}</td>
                        {
                            onDelete ?
                                <td className="delete-btn">
                                    <CustomButton buttonType={ButtonType.delete} onClick={() => onDelete(epiReport.epiReportId)} buttonText="" />
                                </td>
                                : null
                        }
                    </tr>
                </tbody>
            </Table>
        </>
    )
}